module.exports = "/_next/static/images/142d5e23072120e02a8edb5041ea0ea8-frozen-icon.svg.webp";